import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './MobButton.css';

type Variant = 'primary' | 'secondary' | 'danger';

interface MobButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
  children: ReactNode;
}

export function MobButton({
  variant = 'primary',
  loading = false,
  fullWidth = false,
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: MobButtonProps) {
  const isDisabled = disabled || loading;
  const cls = [
    'mob-btn',
    `mob-btn--${variant}`,
    fullWidth ? 'mob-btn--full' : '',
    isDisabled ? 'is-disabled' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={cls}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="mob-btn__spinner" aria-hidden="true" /> : null}
      <span className="mob-btn__label">{children}</span>
    </button>
  );
}
